import { createConstants, createApiConstants } from '@saucelabs/sl-util-redux';
import { constants as deviceConstants } from '@saucelabs/sl-component-device';
import { apiBaseUrls } from '@saucelabs/sl-util-config';

export const NAMESPACE = 'manual';
const createApiNamespacedConstants = createApiConstants.bind(null, NAMESPACE);

export const SESSION = createConstants(NAMESPACE, 'session')('SELECT', 'ADD', 'CLOSE');
export const OPTIONS_GET = createApiNamespacedConstants('OPTIONS_GET');
export const METADATA_GET = createApiNamespacedConstants('METADATA_GET');
export const METADATA_PUT = createApiNamespacedConstants('METADATA_PUT');
export const RECENT_CONFIGS_PUT = createApiNamespacedConstants('RECENT_CONFIGS_PUT');
export const SAVED_CONFIGS_PUT = createApiNamespacedConstants('SAVED_CONFIGS_PUT');
export const INITIAL_DATA = createApiNamespacedConstants('INITIAL_DATA');
export const JOB_GET = createApiNamespacedConstants('JOB_GET');
export const JOB_ID_BASED_ON_TASK_ID_GET = createApiNamespacedConstants('JOB_ID_BASED_ON_TASK_ID_GET');
export const JOB_INITIAL_UPDATE = `${NAMESPACE}/JOB_INITIAL_UPDATE`;

export const DESKTOP_SESSION_POLLING_INTERVAL = 5000;
export const DESKTOP_SESSION_CREATE = createApiNamespacedConstants('DESKTOP_SESSION_CREATE');
export const DESKTOP_SESSION_GET = createApiNamespacedConstants('DESKTOP_SESSION_GET');
export const DESKTOP_SESSION_DELAY = `${NAMESPACE}/DESKTOP_SESSION_DELAY`;
export const DESKTOP_SESSION_AUTO_LAUNCH_TOGGLE = `${NAMESPACE}/DESKTOP_SESSION_AUTO_LAUNCH_TOGGLE`;
export const DESKTOP_SESSION_CLOSE = createApiNamespacedConstants('DESKTOP_SESSION_CLOSE');
export const DESKTOP_SESSION_TAKE_SCREENSHOT = createApiNamespacedConstants('DESKTOP_SESSION_TAKE_SCREENSHOT');
export const DESKTOP_SESSION_JOB_GET = createApiNamespacedConstants('DESKTOP_SESSION_JOB_GET');
export const DESKTOP_SESSION_JOB_INITIAL_UPDATE = `${NAMESPACE}/DESKTOP_SESSION_JOB_INITIAL_UPDATE`;
export const SAVE_DESKTOP_SESSION_TIMEOUT = `${NAMESPACE}/SAVE_DESKTOP_SESSION_TIMEOUT`;
export const SUBSCRIBE_DESKTOP_SESSION = `${NAMESPACE}/SUBSCRIBE_DESKTOP_SESSION`;
export const UNSUBSCRIBE_DESKTOP_SESSION = `${NAMESPACE}/UNSUBSCRIBE_DESKTOP_SESSION`;

export const RDC_OWNER_ID_FETCH = createApiNamespacedConstants('RDC_OWNER_ID_FETCH');
export const RDC_TUNNELS_SUBSCRIBE = createApiNamespacedConstants('RDC_TUNNELS_SUBSCRIBE');

export const APP_MANAGEMENT_EXPERIMENT = 'web-ui-rdc-new-app-management';

const MOBILE_APP_UPLOAD_PREFIX = 'MOBILE_APP_UPLOAD';
export const MOBILE_APP_UPLOAD = {
  ...createApiNamespacedConstants(MOBILE_APP_UPLOAD_PREFIX),
  ...createConstants(NAMESPACE, MOBILE_APP_UPLOAD_PREFIX)('PROGRESS'),
};
export const MOBILE_APPS_FETCH = createApiNamespacedConstants('MOBILE_APPS_FETCH');
export const SET_FILTER_ITEMS = `${NAMESPACE}/SET_FILTER_ITEMS`;

export const MOBILE_DEVICE_ANIMATIONS_TOGGLE = createApiNamespacedConstants('MOBILE_DEVICE_ANIMATIONS_TOGGLE');
export const MOBILE_DEVICE_APP_RESTART = createApiNamespacedConstants('MOBILE_DEVICE_APP_RESTART');
export const MOBILE_SESSION_APP_VERSIONS_FETCH = createApiNamespacedConstants('MOBILE_SESSION_APP_VERSIONS_FETCH');
export const MOBILE_SESSION_APP_VERSION_FETCH = createApiNamespacedConstants('MOBILE_SESSION_APP_VERSION_FETCH');
export const MOBILE_DEVICE_CONNECT = createApiNamespacedConstants('MOBILE_DEVICE_CONNECT');
export const MOBILE_DEVICE_LANGUAGES_FETCH = createApiNamespacedConstants('MOBILE_DEVICE_LANGUAGES_FETCH');
export const MOBILE_DEVICE_LANGUAGE_SET = createApiNamespacedConstants('MOBILE_DEVICE_LANGUAGE_SET');
export const MOBILE_DEVICE_HARDWARE_BUTTON_PRESS = createApiNamespacedConstants('MOBILE_DEVICE_HARDWARE_BUTTON_PRESS');
export const MOBILE_DEVICE_ROTATE = createApiNamespacedConstants('MOBILE_DEVICE_ROTATE');
export const MOBILE_DEVICE_BIOMETRICS_AUTHENTICATION = createApiNamespacedConstants('MOBILE_DEVICE_BIOMETRICS_AUTHENTICATION');
export const MOBILE_DEVICE_SHARE_SESSION = createApiNamespacedConstants('MOBILE_DEVICE_SHARE_SESSION');
export const MOBILE_DEVICE_GPS_LOCATION_CHANGE = `${NAMESPACE}/MOBILE_DEVICE_GPS_LOCATION_CHANGE`;
export const MOBILE_DEVICE_GPS_LOCATION_SET = createApiNamespacedConstants('MOBILE_DEVICE_GPS_LOCATION_SET');
export const MOBILE_DEVICE_STATE_UPDATE = `${NAMESPACE}/MOBILE_DEVICE_STATE_UPDATE`;
export const MOBILE_DEVICE_APP_INSTALL = createApiNamespacedConstants('MOBILE_DEVICE_APP_INSTALL');
export const MOBILE_DEVICE_TAKE_SCREENSHOT = createApiNamespacedConstants('MOBILE_DEVICE_TAKE_SCREENSHOT');
export const MOBILE_DEVICE_WIFI_TOGGLE = createApiNamespacedConstants('MOBILE_DEVICE_WIFI_TOGGLE');
export const MOBILE_DEVICE_SHOW_LOGS = `${NAMESPACE}/MOBILE_DEVICE_SHOW_LOGS`;
export const MOBILE_LOG_SHOW = `${NAMESPACE}/MOBILE_LOG_SHOW`;
export const MOBILE_VITALS_SHOW = `${NAMESPACE}/MOBILE_VITALS_SHOW`;
export const MOBILE_VITALS_GRAPH_HEIGHT_CHANGE = `${NAMESPACE}/MOBILE_VITALS_GRAPH_HEIGHT_CHANGE`;
export const MOBILE_VITALS_LAYOUT_FULLWIDTH_CHANGE = `${NAMESPACE}/MOBILE_VITALS_LAYOUT_FULLWIDTH_CHANGE`;
export const MOBILE_VITALS_DOWNLOAD_LOG = `${NAMESPACE}/MOBILE_VITALS_DOWNLOAD_LOG`;
export const MOBILE_DEVICE_FETCH = createApiNamespacedConstants('MOBILE_DEVICE_FETCH');
export const MOBILE_DEVICES_FETCH = createApiNamespacedConstants('MOBILE_DEVICES_FETCH');
export const MOBILE_DEVICE_TILE_DETAILS_OPEN = `${NAMESPACE}/MOBILE_DEVICE_TILE_DETAILS_OPEN`;
export const MOBILE_DEVICE_TILE_DETAILS_CLOSE = `${NAMESPACE}/MOBILE_DEVICE_TILE_DETAILS_CLOSE`;
export const MOBILE_SESSION_CREATE = createApiNamespacedConstants('MOBILE_SESSION_CREATE');
export const MOBILE_SESSION_STOP = createApiNamespacedConstants('MOBILE_SESSION_STOP');
export const MOBILE_AVAILABLE_DEVICE_IDS_FETCH = createApiNamespacedConstants('MOBILE_AVAILABLE_DEVICE_IDS_FETCH');
export const MOBILE_SESSION_AVAILABLE_FETCH = createApiNamespacedConstants('MOBILE_SESSION_AVAILABLE_FETCH');
export const MOBILE_DEVICE_OPEN_URL = createApiNamespacedConstants('MOBILE_DEVICE_OPEN_URL');
export const MOBILE_DEVICE_PASTE_CONTENT = createApiNamespacedConstants('MOBILE_DEVICE_PASTE_CONTENT');
export const MOBILE_DEVICE_EXECUTE_ADB_SHELL = createApiNamespacedConstants('MOBILE_DEVICE_EXECUTE_ADB_SHELL');
export const MOBILE_DEVICES_FACETS_CLEANUP = `${NAMESPACE}/MOBILE_DEVICES_FACETS_CLEANUP`;

export const SET_DATACENTER_ID = `${NAMESPACE}/SET_DATACENTER_ID`;
export const LS_LAST_DATACENTER_ID = 'lastDataCenterId';

export const APP_UPLOAD_STATUS = {
  CANCELED: 'CANCELED',
  FAILED: 'FAILED',
  UPLOADED: 'UPLOADED',
  UPLOADING: 'UPLOADING',
};
export const APP_UPLOAD_ERROR_MESSAGE = 'Upload failed';
export const APP_UPLOAD_CANCEL_MESSAGE = 'Upload canceled';

export const MOBILE_DEVICE_HARDWARE_BUTTON_TYPES = {
  BACK: 'BACK',
  HOME: 'HOME',
  MENU: 'MENU',
  SEARCH: 'SEARCH',
};

export const FORM_TAB_STATES = {
  WEB_DEVICE_TYPE: {
    DESKTOP: 'DESKTOP',
    MOBILE_VIRTUAL: 'MOBILE_VIRTUAL',
    MOBILE_REAL: 'MOBILE_REAL',
  },
  PLATFORM_TYPE: {
    WEB: 'WEB',
    MOBILE: 'MOBILE',
  },
  DEVICE: {
    DESKTOP: 'DESKTOP',
    MOBILE: 'MOBILE',
  },
  DEVICE_TYPE: {
    REAL: 'REAL',
    VIRTUAL: 'VIRTUAL',
  },
};

export const FORM_TYPES = {
  DESKTOP_BROWSER: 'DESKTOP_BROWSER',
  VIRTUAL_DEVICE: 'VIRTUAL_DEVICE',
  REAL_DEVICE: 'REAL_DEVICE',
  MOBILE_APP: 'MOBILE_APP',
};

export const CREATE_MOBILE_SESSION_ERRORS = {
  DEVICE_NOT_AVAILABLE: 'DEVICE_NOT_AVAILABLE',
  DEVICE_NOT_INCLUDED_IN_PLAN: 'DEVICE_NOT_INCLUDED_IN_PLAN',
  PARALLEL_SESSIONS_LIMIT_REACHED: 'PARALLEL_SESSIONS_LIMIT_REACHED',
};

export const CREATE_MOBILE_SESSION_ERROR_MESSAGES = {
  DEVICE_NOT_AVAILABLE: 'Device currently in use.',
  DEVICE_NOT_INCLUDED_IN_PLAN: 'Device not included in your plan. Please upgrade.',
  PARALLEL_SESSIONS_LIMIT_REACHED: 'Limit of parallel sessions reached. Please upgrade.',
};

export const CREATE_MOBILE_SESSION_ERROR_MESSAGE_DEFAULT = 'Session could not be created.';

export const MOBILE_SESSION_STATES = {
  SESSION_CREATION_FAILED: 'SESSION_CREATION_FAILED',
  DEVICE_CONNECTION_FAILED: 'DEVICE_CONNECTION_FAILED',
  DEVICE_DISCONNECTED: 'DEVICE_DISCONNECTED',
  APP_INSTALLATION_FAILED: 'APP_INSTALLATION_FAILED',
  INITIAL: 'INITIAL',
  REQUESTING: 'REQUESTING',
  ALLOCATING: 'ALLOCATING',
  PREPARING: 'PREPARING',
  INSTALLING: 'INSTALLING',
  READY: 'READY',
};

export const MOBILE_SESSION_STATE_VALUES = {
  SESSION_CREATION_FAILED: {
    duration: 0,
    message: 'Session creation failed',
    percent: 0,
    state: deviceConstants.STATES.ERROR,
  },
  DEVICE_CONNECTION_FAILED: {
    duration: 0,
    message: 'Device connection failed',
    percent: 0,
    state: deviceConstants.STATES.ERROR,
  },
  DEVICE_DISCONNECTED: {
    duration: 0,
    message: 'Device disconnected',
    percent: 0,
    state: deviceConstants.STATES.ERROR,
  },
  APP_INSTALLATION_FAILED: {
    duration: 0,
    message: 'App installation failed',
    percent: 0,
    state: deviceConstants.STATES.ERROR,
  },
  INITIAL: {
    duration: 0,
    message: 'Loading...',
    percent: 0,
    state: deviceConstants.STATES.PROGRESS,
  },
  REQUESTING: {
    duration: 1,
    message: 'Requesting...',
    percent: 10,
    state: deviceConstants.STATES.PROGRESS,
  },
  ALLOCATING: {
    duration: 2,
    message: 'Allocating a device...',
    percent: 20,
    state: deviceConstants.STATES.PROGRESS,
  },
  PREPARING: {
    duration: 30,
    message: 'Preparing the device...',
    percent: 80,
    state: deviceConstants.STATES.PROGRESS,
  },
  INSTALLING: {
    duration: 5,
    message: 'Installing your app...',
    percent: 99,
    state: deviceConstants.STATES.PROGRESS,
  },
  READY: {
    duration: 1,
    message: 'Ready',
    percent: 100,
    state: deviceConstants.STATES.INFO,
  },
};

export const MOBILE_DEVICE_STATES = {
  OFFLINE: 'OFFLINE',
  LAUNCH: 'LAUNCH',
  VIDEO: 'VIDEO',
  BOOTED: 'BOOTED',
  INPUT: 'INPUT',
  ONLINE: 'ONLINE',
};

export const MOBILE_DEVICE_ORIENTATIONS = {
  LANDSCAPE: 'LANDSCAPE',
  PORTRAIT: 'PORTRAIT',
};

export const MOBILE_DRAWER_SHOW = `${NAMESPACE}/MOBILE_DRAWER_SHOW`;
export const MOBILE_DRAWER_SET_HEIGHT = `${NAMESPACE}/MOBILE_DRAWER_SET_HEIGHT`;
export const MOBILE_DRAWER_SET_WIDTH = `${NAMESPACE}/MOBILE_DRAWER_SET_WIDTH`;

export const MOBILE_LOG_LINES_LIMIT = 200;
export const MOBILE_LOG_DISPLAYED_LINES_UPDATE_INTERVAL = 200; // milliseconds

export const MOBILE_LOG_LINE_ADD = `${NAMESPACE}/MOBILE_LOG_LINE_ADD`;
export const MOBILE_LOG_LINES_LOAD_MORE = `${NAMESPACE}/MOBILE_LOG_LINES_LOAD_MORE`;
export const MOBILE_LOG_LINES_PAUSE = `${NAMESPACE}/MOBILE_LOG_LINES_PAUSE`;
export const MOBILE_LOG_LINES_RESUME = `${NAMESPACE}/MOBILE_LOG_LINES_RESUME`;
export const MOBILE_LOG_SET_LOG_LEVEL = `${NAMESPACE}/MOBILE_LOG_SET_LOG_LEVEL`;
export const MOBILE_LOG_CLEAR = `${NAMESPACE}/MOBILE_LOG_CLEAR`;
export const MOBILE_LOG_UPDATE_DISPLAYED_LINES = `${NAMESPACE}/MOBILE_LOG_UPDATE_DISPLAYED_LINES`;
export const MOBILE_LOG_UPDATE_FILTERS = `${NAMESPACE}/MOBILE_LOG_UPDATE_FILTERS`;
export const MOBILE_LOG_DOWNLOAD_LOG = `${NAMESPACE}/MOBILE_LOG_DOWNLOAD_LOG`;
export const MOBILE_LOG_TIME_FORMAT = 'HH:mm:ss';
export const MOBILE_LOG_DATETIME_FORMAT = 'yyyy-MM-dd HH:mm:ss.SSS';
export const MOBILE_LOG_DATETIME_SHORT_FORMAT = 'yyyy-MM-dd_hh-mm';

export const MOBILE_VITALS_ENTRY_ADD = `${NAMESPACE}/MOBILE_VITALS_ENTRY_ADD`;
export const MOBILE_VITALS_UPDATE_VISIBLE_DATA = `${NAMESPACE}/MOBILE_VITALS_UPDATE_VISIBLE_DATA`;
export const MOBILE_VITALS_LAYOUTS = {
  ANDROID: 'ANDROID',
  IOS: 'IOS',
  IOS_LEGACY: 'IOS_LEGACY',
};

/**
 * Session status changes in the following order:
 *
 * +-----+   +--------+   +-------------+   +----------------+   +-------------------+
 * | new +-->+ queued +-->+ in progress +-->+ stop requested +-->+ complete/finished |
 * +-----+   +--------+   +-------------+   +----------------+   +-------------------+
 *
 *                            +-------+
 * It might be interrupted by | error | any time.
 *                            +-------+
 */
// API Statuses
export const SESSION_STATUS_NEW = 'new';
export const SESSION_STATUS_QUEUED = 'queued';
export const SESSION_STATUS_IN_PROGRESS = 'in progress';
export const SESSION_STATUS_COMPLETE = 'complete';
export const SESSION_STATUS_STOP_REQUESTED = 'stop requested';
export const SESSION_STATUS_FINISHED = 'finished';
export const SESSION_STATUS_ERROR = 'error';

// Internal/UI Statuses
export const SESSION_STATUS_CONFIGURING = '_configuring';
export const SESSION_STATUS_WAITING = '_waiting';

export const SESSION_STATUSES_LOADING = [
  SESSION_STATUS_NEW,
  SESSION_STATUS_QUEUED,
];

export const SESSION_STATUSES_COMPLETED = [
  SESSION_STATUS_COMPLETE,
  SESSION_STATUS_ERROR,
  SESSION_STATUS_FINISHED,
  SESSION_STATUS_STOP_REQUESTED,
];

// NOTE: [SESSION_STATE, progress of booting OS, progress of booting Browser]
export const STATUS_PROGRESS_MAP = {
  [SESSION_STATUS_CONFIGURING]: [0, 0], // initial

  // NOTE: RESTo returns one of:
  [SESSION_STATUS_NEW]: [0.5, 0], // initial state (start requested)
  [SESSION_STATUS_QUEUED]: [1.0, 0.5], // setup happens here
  [SESSION_STATUS_IN_PROGRESS]: [1.0, 1.0], // session is running
  [SESSION_STATUS_COMPLETE]: [1.0, 1.0], // finished or terminated
  [SESSION_STATUS_FINISHED]: [1.0, 1.0], // finished or terminated
  [SESSION_STATUS_STOP_REQUESTED]: [1.0, 1.0], // finished or terminated
  [SESSION_STATUS_ERROR]: [0, 0], // error
};

export const SAUCE_CONNECT_PUBLIC_RDC_DISABLED_ERROR = {
  text: `Your current settings have <b>Sauce Connect for Public Cloud disabled</b>. If you are a
  team admin, you can enable this feature in your Real Devices Automation Settings, or
  contact your <b>team admin</b> to enable this feature for your team.`,
  header: 'Sauce Connect Settings Conflict',
};

export const OS_FILTERS = ['IOS', 'ANDROID'];

export const LAST_CHANGE_TIME_FORMAT = 'MMM dd, yyyy H:mm O';

export const SESSION_DEFAULT_URL = 'https://www.saucedemo.com/';
export const TESTOBJECT_FASTSWITCH_URL = `${apiBaseUrls.encore}/signup/test_object`;
export const APP_TESTING_WIKI_URL = 'https://wiki.saucelabs.com/display/DOCS/Live+Testing+for+Native+Mobile+Apps+on+Real+Devices';
